// @ts-ignore
import {ApiValidation} from "../../model/api/api-validation";
import {TableRecordResult} from "../../model/api/table-record-result";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {ETicket} from "../../model/eticket/e-ticket";

export class CrystalclearEticketBackUrl {

  static readonly GET_ETICKET_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<ETicket>> = {
    url: '/api/eticket/list',
    type: TableRecordResult
  };

  static readonly SAVE_ETICKET: CrystalclearBackUrl.UrlConf<ApiValidation<ETicket>> = {
    url: '/api/eticket/save',
    type: ApiValidation
  };

  static readonly DELETE_ETICKET: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/eticket/delete',
    type: ApiValidation
  };

  static readonly GET_DESKS: CrystalclearBackUrl.UrlConf<ApiValidation<string[]>> = {
    url: '/api/eticket/desks',
    type: ApiValidation
  };
}
